module.exports = {"private":true,"main":"./AppContainer.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/frags/AppContainer/package.json
// module id = 840
// module chunks = 0 1